<template>
  <div class="phb">
    <el-tabs value='jjphb'
             @tab-click="handleClick">
      <el-tab-pane label="将军排行榜"
                   name="jjphb">
      </el-tab-pane>
      <el-tab-pane label="军团排行榜"
                   name="jtphb">
      </el-tab-pane>
      <el-tab-pane label="部直属单位"
                   name="bzsdw">

      </el-tab-pane>
      <el-tab-pane label="省"
                   name="province">

      </el-tab-pane>
      <el-tab-pane label="市"
                   name="city">

      </el-tab-pane>
      <el-tab-pane label="县"
                   name="county">
      </el-tab-pane>
    </el-tabs>
    <div>
      <el-table stripe
                size='small'
                :header-cell-style="{background:'#eef1f6',padding:'1px 0px',color:'black'}"
                style="width: 100%; font-size: 12px; color: black"
                ref="multipleTable1"
                :data="tableData"
                v-loading="loading"
                element-loading-text="拼命加载中"
                tooltip-effect="dark"
                :height="710">
        <el-table-column type="selection"
                         width="55">
        </el-table-column>
        <el-table-column :prop="currentcloumn.enname[index]"
                         :label="item"
                         v-for="(item, index) in currentcloumn.title"
                         :key="index"
                         :sort-method="(a, b) => {return a[item.props] - b[item.props]}"> </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { getjjphb, getjtphb, getbzsdw, getprovince, getcity, getdist } from "@/utils/request";
export default {
  data () {
    return {
      loading: false,
      dwform: {},
      currentTab: '',
      jjphb: { title: ['姓名', '单位', '得分', '排名'], enname: ['name', 'department', 'score', 'pm'] },
      jtphb: { title: ['单位', '得分', '排名'], enname: ['department', 'score', 'pm'] },
      bzsdw: { title: ['单位', '得分', '排名'], enname: ['lsgx', 'score', 'pm'] },
      province: { title: ['名称', '得分', '排名'], enname: ['region', 'score', 'pm'] },
      city: { title: ['名称', '得分', '排名'], enname: ['city', 'score', 'pm'] },
      county: { title: ['名称', '得分', '排名'], enname: ['dist', 'score', 'pm'] },
      tableData: [
      ],
    }
  },
  methods: {
    queryBzTable () {
      this.loading = true
      //debugger
      this.tableData = []
      //请求表格数据
      /* this.$http.get('http://192.168.0.177/sajj/gthmmc/index.php?m=ias&c=manager&a=getPaihang&from=xcx&destination_id=499&showtype=1', {
      }).then(res => {
        console.log(res.data);
        this.tableData = res.data.data;
        this.tableData.forEach((v, index) => {
          v.pm = index + 1
        });
        this.loading = false;
      }); */
      return getjjphb().then(
        (res) => {
          console.log(res.data);
          this.tableData = res.data.data;
          if (this.tableData !== undefined) {
            this.tableData.forEach((v, index) => {
              v.pm = index + 1
            });
          }
          this.loading = false;
        },
      )
    },
    queryjtTable () {
      this.loading = true
      //debugger
      this.tableData = []
      //请求表格数据
      /* this.$http.get('http://192.168.0.177/sajj/gthmmc/index.php?m=ias&c=manager&a=getPaihang&from=xcx&destination_id=499&showtype=2', {
      }).then(res => {
        console.log(res.data);
        this.tableData = res.data.data;
        this.tableData.forEach((v, index) => {
          v.pm = index + 1
        });
        this.loading = false;
      }); */
      return getjtphb().then(
        (res) => {
          console.log(res.data);
          this.tableData = res.data.data;
          if (this.tableData !== undefined) {
            this.tableData.forEach((v, index) => {
              v.pm = index + 1
            });
          }
          this.loading = false;
        },
      )
    },
    querybzsdwTable () {
      this.loading = true
      //debugger
      this.tableData = []
      //请求表格数据
      /* this.$http.get('http://192.168.0.177/sajj/gthmmc/index.php?m=ias&c=manager&a=getPaihang&from=xcx&destination_id=499&showtype=8', {
      }).then(res => {
        console.log(res.data);
        this.tableData = res.data.data;
        this.tableData.forEach((v, index) => {
          v.pm = index + 1
        });
        this.loading = false;
      }); */
      return getbzsdw().then(
        (res) => {
          console.log(res.data);
          this.tableData = res.data.data;
          if (this.tableData !== undefined) {
            this.tableData.forEach((v, index) => {
              v.pm = index + 1
            });
          }
          this.loading = false;
        },
      )
    },
    queryprovince () {
      this.loading = true
      //debugger
      this.tableData = []
      //请求表格数据
      /* this.$http.get('http://192.168.0.177/sajj/gthmmc/index.php?m=ias&c=manager&a=getPaihang&from=xcx&destination_id=499&showtype=3', {
      }).then(res => {
        console.log(res.data);
        this.tableData = res.data.data;
        this.tableData.forEach((v, index) => {
          v.pm = index + 1
        });
        this.loading = false;
      }); */
      return getprovince().then(
        (res) => {
          console.log(res.data);
          this.tableData = res.data.data;
          if (this.tableData !== undefined) {
            this.tableData.forEach((v, index) => {
              v.pm = index + 1
            });
          }
          this.loading = false;
        },
      )
    },
    querycity () {
      this.loading = true
      //debugger
      this.tableData = []
      //请求表格数据
      /* this.$http.get('http://192.168.0.177/sajj/gthmmc/index.php?m=ias&c=manager&a=getPaihang&from=xcx&destination_id=499&showtype=9', {
      }).then(res => {
        console.log(res.data);
        this.tableData = res.data.data;
        this.tableData.forEach((v, index) => {
          v.pm = index + 1
        });
        this.loading = false;
      }); */
      return getcity().then(
        (res) => {
          console.log(res.data);
          this.tableData = res.data.data;
          if (this.tableData !== undefined) {
            this.tableData.forEach((v, index) => {
              v.pm = index + 1
            });
          }
          this.loading = false;
        },
      )
    },
    querydist () {
      this.loading = true
      //debugger
      this.tableData = []
      //请求表格数据
      /* this.$http.get('http://192.168.0.177/sajj/gthmmc/index.php?m=ias&c=manager&a=getPaihang&from=xcx&destination_id=499&showtype=10', {
      }).then(res => {
        console.log(res.data);
        this.tableData = res.data.data;
        this.tableData.forEach((v, index) => {
          v.pm = index + 1
          v.dist = v.city + "-" + v.dist
        });
        this.loading = false;
      }); */
      return getdist().then(
        (res) => {
          console.log(res.data);
          this.tableData = res.data.data;
          if (this.tableData !== undefined) {
            this.tableData.forEach((v, index) => {
              v.pm = index + 1
              v.dist = v.city + '-' + v.dist
            });
          }
          this.loading = false;
        },
      )
    },
    handleClick (tab, event) {
      this.currentTab = event.target.getAttribute('id')
      console.log(this.tableData);
      switch (this.currentTab) {
        case "tab-jjphb":
          this.queryBzTable();
          break
        case "tab-jtphb":
          this.queryjtTable();
          break
        case "tab-bzsdw":
          this.querybzsdwTable();
          break
        case "tab-province":
          this.queryprovince();
          break
        case "tab-city":
          this.querycity();
          break
        case "tab-county":
          this.querydist();
          break
        default:
          this.queryBzTable();
          break
      }
    },
  }
  ,
  created () {
    this.dwform = JSON.parse(localStorage.getItem('dwform'))
    this.queryBzTable()
  },
  computed: {
    currentcloumn () {
      switch (this.currentTab) {
        case "tab-jjphb":
          return this.jjphb
        case "tab-jtphb":
          return this.jtphb
        case "tab-bzsdw":
          return this.bzsdw
        case "tab-province":
          return this.province
        case "tab-city":
          return this.city
        case "tab-county":
          return this.county
        default:
          return this.jjphb
      }
    }
  }
}
</script>

<style lang="less" scoped>
</style>